import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const formatDataService = {};

// Đăng ký sử dụng
formatDataService.listRegistryInvoices = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/registry-invoices`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code,
    },
  });
};
// reviewPdfRegisterInvoice
formatDataService.reviewPdfRegisterInvoice = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/registry-invoices/review-pdf/${id}`,
    method: "get",
  });
};
// Kiểm tra tờ khai hiệu lực
formatDataService.checkInvoicesCurrent = function () {
  return fetch({
    url: `${env.API_MSP}/registry-invoices/current`,
    method: "get",
    params: {
      expand: "registryInvoiceCas",
    },
  });
};
// Detail Đăng ký sử dụng
formatDataService.detailRegistryInvoices = function (id) {
  return fetch({
    url: `${env.API_MSP}/registry-invoices/${id}`,
    method: "get",
    params: {
      expand: "registryInvoiceCas",
    },
  });
};

// Create Đăng ký sử dụng
formatDataService.createRegistryInvoices = function (data, bu_code) {
  return fetch({
    url: `${env.API_MSP}/registry-invoices`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// Edit Đăng ký sử dụng
formatDataService.editRegistryInvoices = function (data, id) {
  return fetch({
    url: `${env.API_MSP}/registry-invoices/${id}`,
    method: "put",
    data,
  });
};

// Ủy quyền lập hóa đơn
formatDataService.listRegistryDelegate = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort
) {
  return fetch({
    url: `${env.API_MSP}/registry-delegates`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
    },
  });
};

// Detail Ủy quyền lập hóa đơn
formatDataService.detailRegistryDelegate = function (id) {
  return fetch({
    url: `${env.API_MSP}/registry-delegates/${id}`,
    method: "get",
    params: {
      expand: "registryDelegateCas,registryDelegateInvoices",
    },
  });
};

// Create Ủy quyền lập hóa đơn
formatDataService.createRegistryDelegate = function (data) {
  return fetch({
    url: `${env.API_MSP}/registry-delegates`,
    method: "post",
    data,
  });
};

// Edit Ủy quyền lập hóa đơn
formatDataService.editRegistryDelegate = function (data, id) {
  return fetch({
    url: `${env.API_MSP}/registry-delegates/${id}`,
    method: "put",
    data,
  });
};

// Đề nghị cấp HDDT có mã
formatDataService.listRequestInvoiceCodes = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort
) {
  return fetch({
    url: `${env.API_MSP}/request-invoice-codes`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
    },
  });
};

// Detail Đề nghị cấp HDDT có mã
formatDataService.detailRequestInvoiceCode = function (id) {
  return fetch({
    url: `${env.API_MSP}/request-invoice-codes/${id}`,
    method: "get",
    params: {
      expand: "requestContent",
    },
  });
};

// Create Đề nghị cấp HDDT có mã
formatDataService.createRequestInvoiceCode = function (data) {
  return fetch({
    url: `${env.API_MSP}/request-invoice-codes`,
    method: "post",
    data,
  });
};

// Edit Đề nghị cấp HDDT có mã
formatDataService.editRequestInvoiceCode = function (data, id) {
  return fetch({
    url: `${env.API_MSP}/request-invoice-codes/${id}`,
    method: "put",
    data,
  });
};

// downloadFileXMLRegistryInvoices
formatDataService.downloadFileXMLRegistryInvoices = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/registry-invoices/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};
// downloadFilePDFRegistryInvoices approve-pdf-error
formatDataService.downloadFilePDFRegistryInvoices = ({
  resource_id,
  downloadType,
  responseType,
}) => {
  if (downloadType == "approve-pdf-error") {
    return fetch({
      url: `${env.API_MSP}/invoice-errors/approve-pdf/${resource_id}`,
      method: "get",
    });
  } else {
    return fetch({
      url: `${env.API_MSP}/registry-invoices/${
        downloadType + "/" + resource_id
      }`,
      method: "get",
    });
  }
};
// downloadFileXMLRegistryDelegates
formatDataService.downloadFileXMLRegistryDelegates = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/registry-delegates/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// downloadFileXMLRequestInvoiceCode
formatDataService.downloadFileXMLRequestInvoiceCode = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/request-invoice-codes/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// releaseRegistryInvoices
formatDataService.releaseRegistryInvoices = id => {
  return fetch({
    url: `${env.API_MSP}/registry-invoices/release/${id}`,
    method: "post",
  });
};

// releaseRegistryDelegates
formatDataService.releaseRegistryDelegates = id => {
  return fetch({
    url: `${env.API_MSP}/registry-delegates/release/${id}`,
    method: "post",
  });
};

// releaseRequestInvoiceCodes
formatDataService.releaseRequestInvoiceCodes = id => {
  return fetch({
    url: `${env.API_MSP}/request-invoice-codes/release/${id}`,
    method: "post",
  });
};

// previewPDF
formatDataService.previewPDF = function (resourceId) {
  return fetch({
    url: `${env.API_MSP}/case-docsigns/file/${resourceId}`,
    method: "get",
    responseType: "blob",
  });
};

// transfer
formatDataService.transfer = function (data) {
  return fetch({
    url: `${env.API_MSP}/hooks/transfer`,
    method: "post",
    data,
  });
};

// errorRelease
formatDataService.errorRelease = function (id, path) {
  return fetch({
    url: `${env.API_MSP}/${path}/error/${id}`,
    method: "get",
  });
};

// historyTransfer
formatDataService.historyTransfer = function (id, path) {
  let type = null;
  let typeAction = undefined;
  switch (path) {
    case "invoices":
    case "invoice-tickets":
      type = 1;
      break;
    case "registry-invoices":
      type = 2;
      break;
    case "invoice-errors":
      break;
    case "invoices-send-mail":
      type = 1;
      typeAction = 5;
      break;
    default:
      break;
  }
  if (type) {
    const url = `${env.API_MSP}/histories`;
    return fetch({
      url: url,
      method: "get",
      params: {
        "filter[object_id]": id,
        "filter[type]": type,
        "filter[type_action]": typeAction,
      },
    });
  } else {
    return fetch({
      url: `${env.API_MSP}/${path}/history/${id}`,
      method: "get",
    });
  }
};

export default formatDataService;
